<template>
  <v-menu
    v-model="isActive"
    offset-y
    transition="slide-y-transition"
    rounded="1"
    max-width="176"
    :nudge-top="-10"
    :nudge-left="-166"
    right
    content-class="filter__list mod--status LKRoadmapsFeedFilterStatus"
  >
    <template #activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <FilterToggle
          title="Статус ДК:"
          :desc="selectedString"
          :active="isActive"
        />
      </div>
    </template>

    <div
      v-for="item in statuses"
      :key="item.label"
      class="filter__option w-inline-block text-md-bold"
      :class="{ 'mod--active': item.value === value }"
      @click="select(item.value)"
      v-text="item.label"
    />
  </v-menu>
</template>

<script>
import FilterToggle from './LKRoadmapsFeedFilterToggle.vue'


const STATUSES = [
  { label: 'Все Статусы', value: void 0 },
  { label: 'Подтверждено', value: true },
  { label: 'Не Подтверждено', value: false },
]

export default {
  name: 'LKRoadmapsFeedFilterStatus',
  components: {
    FilterToggle,
  },
  data: () => ({
    isActive: false,
    value: STATUSES[0].value,
    statuses: STATUSES,
  }),
  computed: {
    selectedString() {
      const selected = (
        this.statuses.find((_) => _.value === this.value)
        || STATUSES[0]
      )
      return selected.label
    },
  },
  methods: {
    select(value) {
      this.value = value
      this.$emit('submit', value)
    },
  },
}
</script>

<style lang="scss">
.LKRoadmapsFeedFilterStatus {
  .filter__option {
    cursor: pointer;

    &.mod--active {
      pointer-events: none;
      cursor: default;
    }
  }
}
</style>
